import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();

const emit = () => {
  for (const listener of listeners) listener();
};

export const openPartnerSwitcher = (): void => {
  if (open) return;
  open = true;
  emit();
};

export const closePartnerSwitcher = (): void => {
  if (!open) return;
  open = false;
  emit();
};

const subscribe = (callback: () => void): (() => void) => {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
};

const getSnapshot = (): boolean => open;

export const usePartnerSwitcherOpen = (): boolean => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
